import ReactDOM from 'react-dom';
import { theme } from '@fiverr-private/theme';
import { DEFAULT_TIMEOUT } from '../constants';
import { LocationsType } from '../types';
import { BASE_CLASS, GUTTER } from './constants';

/**
 * A map of all toasts timeouts, where the key is the toast element, and the value is the corresponding timeout for its dismissal.
 */
export const timeouts = new Map();

/**
 * Removes a toast from its containing tray.
 */
export const remove = (toast: HTMLElement, callback = Function.prototype) => {
    toast.addEventListener('transitionend', function cb(e) {
        if (e.target !== toast) {
            return;
        }

        toast.removeEventListener('transitionend', cb);
        callback(e);

        if (!toast.parentElement) {
            return;
        }

        ReactDOM.unmountComponentAtNode(toast);
        toast.parentElement.removeChild(toast);
    });

    toast.style.opacity = theme.opacity['0'];
    toast.style.transform += ' scale(.8)';
};

/**
 * Schedules a toast's removal from its containing tray.
 */
export const scheduleRemoval = (
    toast: HTMLElement,
    { duration = DEFAULT_TIMEOUT, callback = Function.prototype, removeFn = remove } = {}
) => {
    timeouts.set(
        toast,
        setTimeout(() => {
            removeFn(toast, callback);
        }, duration)
    );
};

/**
 * Creates a toast element.
 */
export const create = (duration = DEFAULT_TIMEOUT) => {
    const toast = document.createElement('li');

    toast.classList.add(BASE_CLASS);
    toast.onmouseenter = () => {
        clearTimeout(timeouts.get(toast));
    };
    toast.onmouseleave = () => {
        if (duration !== Infinity) {
            scheduleRemoval(toast, { duration });
        }
    };

    return toast;
};

/**
 * Fetches the correct toast styles, based on location.
 */
export const getStyle = (location: LocationsType) => {
    switch (location) {
        case 'top-start':
            return {
                top: 0,
                left: `${GUTTER}px`,
            };
        case 'top':
            return {
                top: 0,
                left: '50%',
            };
        case 'top-end':
            return {
                top: 0,
                right: `${GUTTER}px`,
            };
        case 'bottom-start':
            return {
                bottom: 0,
                left: `${GUTTER}px`,
            };
        case 'bottom':
            return {
                bottom: 0,
                left: '50%',
            };
        case 'bottom-end':
            return {
                bottom: 0,
                right: `${GUTTER}px`,
            };
        default:
            return {};
    }
};
